import angular from 'angular';

import controller from './vdpConsumerReviewTags.controller';

export default angular.module('vdp.consumerReviewTags', [])

.controller('vdpConsumerReviewTags', controller)

.name;
